// extracted by mini-css-extract-plugin
module.exports = {"block":"StatusContainer_block__hl1XC"};